const frDict = {
  'Account recovery requires verified contact information': 'La récupération du compte nécessite des informations de contact vérifiées',
  'Back to Sign In': 'Retour à la connexion',
  'Change Password': 'Modifier le mot de passe',
  Changing: 'Modification en cours',
  Code: 'Code',
  'Confirm Password': 'Confirmez le mot de passe',
  'Confirm Sign Up': "Confirmer l'inscription",
  'Confirm SMS Code': 'Confirmer le code SMS',
  'Confirm TOTP Code': 'Confirmer le code TOTP',
  Confirm: 'Confirmer',
  'Confirmation Code': 'Code de confirmation',
  Confirming: 'Confirmation',
  'Create a new account': 'Créer un nouveau compte',
  'Create Account': 'Créer un compte',
  'Creating Account': `Création d'un compte`,
  'Dismiss alert': `Supprimer l'alerte`,
  Email: 'Email',
  'Enter your code': 'Saisissez cotre code de confirmation',
  'Enter your Email': 'Saisissez votre adresse e-mail',
  'Enter your email': 'Saisissez votre adresse e-mail',
  'Enter your phone number': 'Saisissez votre numéro de téléphone',
  'Enter your username': "Saisissez votre nom d'utilisateur",
  'Forgot your password?': 'Mot de passe oublié ? ',
  'Hide password': 'Masquer le mot de passe',
  'It may take a minute to arrive': 'Cela peut prendre une minute',
  Loading: 'Chargement en cours',
  'New password': 'Nouveau mot de passe',
  or: 'ou',
  Password: 'Mot de passe',
  'Phone Number': 'Numéro de téléphone',
  'Resend Code': 'Renvoyer le code',
  'Reset your Password': 'Réinitialiser votre mot de passe',
  'Reset your password': 'Réinitialisez votre mot de passe',
  'Send code': 'Envoyer le code',
  'Send Code': "M'envoyer un code",
  Sending: 'Envoi en cours',
  'Setup TOTP': 'Configuration de TOTP',
  'Show password': 'Afficher le mot de passe',
  'Sign in to your account': 'Connexion à votre compte',
  'Sign In with Amazon': 'Se connecter avec Amazon',
  'Sign In with Apple': 'Se connecter avec Apple',
  'Sign In with Facebook': 'Se connecter avec Facebook',
  'Sign In with Google': 'Se connecter avec Google',
  'Sign in': 'Se connecter',
  'Sign In': 'Se connecter',
  'Signing in': 'Connexion en cours',
  Skip: 'Passer',
  Submit: 'Soumettre',
  Submitting: 'Envoi en cours',
  Username: "Nom d'utilisateur",
  'Verify Contact': 'Vérifier le contact',
  Verify: 'Vérifier',
  'We Sent A Code': 'Nous avons envoyé un code',
  'We Texted You': 'Nous vous avons envoyé un SMS',
  'Your code is on the way. To log in, enter the code we sent you': `Votre code est en cours d'envoi. Pour vous connecter, saisissez le code que nous vous avons envoyé`,
  // Additional translations provided by customers
  'Add your Profile': 'Ajoutez votre profil',
  'Add your Website': 'Ajoutez votre site web',
  'An account with the given email already exists.': 'Un utilisateur avec cette adresse email existe déjà.',
  Birthdate: 'Date de naissance',
  Change: 'Modifier',
  'Confirm a Code': 'Confirmer un code',
  'Confirm Sign In': 'Confirmer la connexion',
  'Create account': 'Créer un compte',
  'Enter your Birthdate': 'Saisissez votre date de naissance',
  'Enter your Confirmation Code': 'Saisissez votre code de confirmation',
  'Enter your Family Name': 'Saisissez votre nom de famille',
  'Enter your Given Name': 'Saisissez votre prénom',
  'Enter your Middle Name': 'Saisissez votre deuxième prénom',
  'Enter your Name': 'Saisissez votre nom',
  'Enter your Nickname': 'Saisissez votre surnom',
  'Enter your Password': 'Saisissez votre mot de passe',
  'Enter your Phone Number': 'Saisissez votre numéro de téléphone',
  'Enter your Preferred Username': "Saisissez votre nom d'utilisateur",
  'Enter your password': 'Saisissez votre mot de passe',
  'Given Name': 'Prénom',
  'Family Name': 'Nom de famille',
  'Forgot Password': 'Mot de passe oublié',
  'Forgot Password?': 'Mot de passe oublié ?',
  'Incorrect username or password.': 'Identifiant ou mot de passe incorrect.',
  'Have an account? ': 'Déjà un compte ? ',
  Hello: 'Bonjour',
  'Incorrect username or password': 'Identifiant ou mot de passe incorrect',
  'Invalid password format': 'Format de mot de passe invalide',
  'Invalid phone number format': `Format de numéro de téléphone invalide. Veuillez utiliser un format +12345678900`,
  'Loading...': 'Chargement...',
  'Lost your code? ': 'Vous avez perdu votre code ? ',
  'Network error': 'Erreur réseau',
  'New Password': 'Nouveau mot de passe',
  Name: 'Nom',
  'No account? ': 'Pas de compte ? ',
  'Please confirm your Password': 'Confirmez votre mot de passe',
  'Preferred Username': "Nom d'utilisateur préféré",
  Profile: 'Profil',
  'Resend a Code': 'Renvoyer un code',
  'Reset password': 'Réinitialiser le mot de passe',
  'Reset Password': 'Réinitialiser le mot de passe',
  Send: 'Envoyer',
  'Sign In with AWS': 'Se connecter avec AWS',
  'Sign Out': 'Déconnexion',
  'Sign Up': "S'inscrire",
  SMS: 'SMS',
  'User already exists': "L'utilisateur existe déjà",
  'User does not exist': "L'utilisateur n'existe pas",
  'Username cannot be empty': "Le nom d'utilisateur doit être renseigné",
  'Username/client id combination not found.': "L'utilisateur n'existe pas",
  'We Emailed You': 'Nous vous avons envoyé un code',
  'Your code is on the way. To log in, enter the code we emailed to': 'Votre code est en route. Pour vous connecter entrez le code reçu sur cette adresse email',
  'Your code is on the way. To log in, enter the code we texted to': 'Votre code est en route. Pour vous connecter entrez le code reçu sur ce numéro de téléphone',
  'Your passwords must match': 'Vos mots de passe doivent être identiques',
  'It may take a minute to arrive.': 'Cela peut prendre quelques minutes.',
  Website: 'Site web',
  'Password must have at least 8 characters': 'Le mot de passe doit comporter au moins 8 caractères',
  'Password did not conform with policy: Password must have uppercase characters': 'Le mot de passe doit comporter des caractères majuscules',
  'Password did not conform with policy: Password must have numeric characters': 'Le mot de passe doit comporter des caractères numériques',
  'Password did not conform with policy: Password must have symbol characters': 'Le mot de passe doit comporter des symboles',
  'Password did not conform with policy: Password must have lowercase characters': 'Le mot de passe doit comporter des caractères minuscules',
  'Invalid verification code provided, please try again.': 'Code de vérification invalide, veuillez réessayer.',
  'Attempt limit exceeded, please try after some time.': 'Nombre maximum de tentatives dépassé, veuillez réessayer plus tard.',
  'A network error has occurred.': "Une erreur de réseau s'est produite."
};
export { frDict };